module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Tom and Laura have been part of my personal fantasy friends set since I was around ten or eleven. Somewhere in my files, I have a page with my twelve-year-old handwriting on it, detailing them walking across a field of grass.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When I was very young, I was prone to waking-nightmare scenarios I obsessed over before I fell asleep. I would lie in bed thinking about killer shrews and zombies and vampires until I was sick with fear. Then I crept down the hall and snuck into bed next to my mom. I would lie awake and try to be very still so she wouldn’t wake up and take me back to my own room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("At some point, when I was maybe eleven, I thought, “What if I think about something nice instead of scary things?” I imagined dolphins swimming in the ocean, and I fell asleep in my own bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Then I began to tell myself stories, borrowing from everything I read or saw on TV. Tom rose from that story stew, and Laura followed soon after.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Sometimes I was so excited about my stories I had trouble sleeping. They were serial stories, continuing from night to night, and involving a cast of many. Sometimes I’d jump to other stories, in different genres with different casts. There was the Ghost Story crew—Nathan, Susan, Edmund, Julio, and Deirdre"), _c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn1a",
      "id": "fn1"
    }
  }, [_vm._v("*")]), _vm._v("; there was a science fiction/alien invasion series whose details are misty to me now; a fantasy series involving Harry and the Fae"), _c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn2a",
      "id": "fn2"
    }
  }, [_vm._v("*")]), _vm._v("; the LaZelles, Gypsum, Jasper, Opal, Beryl, and Flint"), _c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn3a",
      "id": "fn3"
    }
  }, [_vm._v("*")]), _vm._v("; Janie and Jason, Ceciley, Robin, and others"), _c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn4a",
      "id": "fn4"
    }
  }, [_vm._v("*")]), _vm._v("; and the Tom and Laura series, with Tom’s half-brother Doug, and a host of other folks I only dimly recall, many of whom I haven’t written about yet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Twenty years later, when I was writing for part of a living, I sometimes cheated by writing about characters I already knew and loved. Or it felt like cheating, because it was much easier than making up people out of nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("However, I didn’t know anything about Chapel Hollow until I actually started writing "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("The Thread That Binds the Bones")]), _vm._v(" in the nineties. At that point, I worked on the town of Arcadia (somewhere near Arlington, Oregon, but not in exactly the same spot) and the family tree for the Lockes, Keyes, Boltes, & Seales, and the magic system of powers they use.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Southwater Clan, in Klamath Falls, is less well developed, though people from there figure prominently in "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("The Silent Strength of Stones ")]), _vm._v("and "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Spirits That Walk in Shadow.")]), _vm._v(" They are more secret and integrated into their community, living scattered, and masquerading as normal. There’s lots more for me to explore there.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Nick’s mother comes from one of the Lost Tribes, about whom I know very little as yet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Welcome, or welcome back, to these worlds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn1",
      "id": "fn1a"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Stir of Bones")]), _vm._v(" (Viking, 2003), "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("A Red Heart of Memories")]), _vm._v(" (Ace, 2000), and "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Past the Size of Dreaming")]), _vm._v(" (Ace, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn2",
      "id": "fn2a"
    }
  }, [_vm._v("*")]), _vm._v(" “Flotsam,” in "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Firebirds")]), _vm._v(" (Viking, 2003); and “Immersed in Matter,” in "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("The Faery Reel")]), _vm._v(" (Viking, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn3",
      "id": "fn3a"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("A Fistful of Sky")]), _vm._v(" (Ace, 2002) and "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Fall of Light")]), _vm._v(" (Ace, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('a', {
    attrs: {
      "href": "#/SilentStrength2#fn4",
      "id": "fn4a"
    }
  }, [_vm._v("*")]), _vm._v(" “Ceciley in the Supermarket” ("), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Weird Tales")]), _vm._v(", Spring 1993) and “Entertaining Possibilities” ("), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Time Travelers, Ghosts, and Other Visitors")]), _vm._v(", Five Star/Tekno Books, 2003).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4b0526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SilentStrength-2.vue
// module id = 72
// module chunks = 0